import { render } from "./Comparte.vue?vue&type=template&id=6841c71a&scoped=true"
const script = {}

import "./Comparte.vue?vue&type=style&index=0&id=6841c71a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6841c71a"]])

export default __exports__